import { useEffect, useState } from 'react';
import { normalizeTextForSearch } from '@/utils/commonHelpers';

export const useSearchList = ({
  list = [],
  key = 'name',
  searchTerm = null,
}) => {
  const [listItem, setList] = useState(list);

  useEffect(() => {
    if (!searchTerm) {
      setList(list);
      return;
    }
    const updatedList = list?.filter((l) => {
      const normalizedItemText = normalizeTextForSearch(l?.[key]);
      const normalizedSearchTerm = normalizeTextForSearch(searchTerm);
      return normalizedItemText.includes(normalizedSearchTerm);
    });
    setList(updatedList);
  }, [list, key, searchTerm]);

  return listItem;
};
